/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FuelUpVaultTransactionType } from './FuelUpVaultTransactionType';
import {
    FuelUpVaultTransactionTypeFromJSON,
    FuelUpVaultTransactionTypeFromJSONTyped,
    FuelUpVaultTransactionTypeToJSON,
    FuelUpVaultTransactionTypeToJSONTyped,
} from './FuelUpVaultTransactionType';

/**
 * Audit log of all vault transactions (deposits, withdrawals, bonuses)
 * @export
 * @interface FuelUpVaultTransaction
 */
export interface FuelUpVaultTransaction {
    /**
     * 
     * @type {string}
     * @memberof FuelUpVaultTransaction
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof FuelUpVaultTransaction
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof FuelUpVaultTransaction
     */
    updatedAt: number;
    /**
     * Reference to User ObjectId
     * @type {string}
     * @memberof FuelUpVaultTransaction
     */
    user: string;
    /**
     * Reference to FuelUpVault ObjectId
     * @type {string}
     * @memberof FuelUpVaultTransaction
     */
    vault: string;
    /**
     * 
     * @type {FuelUpVaultTransactionType}
     * @memberof FuelUpVaultTransaction
     */
    type: FuelUpVaultTransactionType;
    /**
     * Amount of fuel (positive for deposits/bonuses, negative for withdrawals)
     * @type {number}
     * @memberof FuelUpVaultTransaction
     */
    amount: number;
    /**
     * Vault balance before this transaction
     * @type {number}
     * @memberof FuelUpVaultTransaction
     */
    balanceBefore: number;
    /**
     * Vault balance after this transaction
     * @type {number}
     * @memberof FuelUpVaultTransaction
     */
    balanceAfter: number;
    /**
     * When transaction occurred
     * @type {Date}
     * @memberof FuelUpVaultTransaction
     */
    timestamp?: Date;
    /**
     * Bonus percentage applied (for bonus transactions)
     * @type {number}
     * @memberof FuelUpVaultTransaction
     */
    bonusRate?: number;
    /**
     * Name of vault bonus tier that granted this bonus
     * @type {string}
     * @memberof FuelUpVaultTransaction
     */
    bonusTierName?: string;
    /**
     * Human-readable transaction description
     * @type {string}
     * @memberof FuelUpVaultTransaction
     */
    note?: string;
}



/**
 * Check if a given object implements the FuelUpVaultTransaction interface.
 */
export function instanceOfFuelUpVaultTransaction(value: object): value is FuelUpVaultTransaction {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('vault' in value) || value['vault'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('balanceBefore' in value) || value['balanceBefore'] === undefined) return false;
    if (!('balanceAfter' in value) || value['balanceAfter'] === undefined) return false;
    return true;
}

export function FuelUpVaultTransactionFromJSON(json: any): FuelUpVaultTransaction {
    return FuelUpVaultTransactionFromJSONTyped(json, false);
}

export function FuelUpVaultTransactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelUpVaultTransaction {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'user': json['user'],
        'vault': json['vault'],
        'type': FuelUpVaultTransactionTypeFromJSON(json['type']),
        'amount': json['amount'],
        'balanceBefore': json['balanceBefore'],
        'balanceAfter': json['balanceAfter'],
        'timestamp': json['timestamp'] == null ? undefined : (new Date(json['timestamp'])),
        'bonusRate': json['bonusRate'] == null ? undefined : json['bonusRate'],
        'bonusTierName': json['bonusTierName'] == null ? undefined : json['bonusTierName'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function FuelUpVaultTransactionToJSON(json: any): FuelUpVaultTransaction {
    return FuelUpVaultTransactionToJSONTyped(json, false);
}

export function FuelUpVaultTransactionToJSONTyped(value?: FuelUpVaultTransaction | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'user': value['user'],
        'vault': value['vault'],
        'type': FuelUpVaultTransactionTypeToJSON(value['type']),
        'amount': value['amount'],
        'balanceBefore': value['balanceBefore'],
        'balanceAfter': value['balanceAfter'],
        'timestamp': value['timestamp'] == null ? undefined : ((value['timestamp']).toISOString()),
        'bonusRate': value['bonusRate'],
        'bonusTierName': value['bonusTierName'],
        'note': value['note'],
    };
}

